import { NewsletterModal } from 'components/_global/layout/newsletter-modal';
import { NewsletterModalContext } from 'contexts/newsletter-modal';
import { ReactNode, useMemo, useState } from 'react';

const NewsletterModalProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);

  const value = useMemo(
    () => ({ openNewsletterModal: () => setIsOpen(true) }),
    []
  );

  return (
    <NewsletterModalContext.Provider value={value}>
      <NewsletterModal isOpen={isOpen} close={() => setIsOpen(false)} />
      {children}
    </NewsletterModalContext.Provider>
  );
};

export default NewsletterModalProvider;
